import { useQuery } from '@tanstack/react-query';
import {
  GraphQLContext,
  useGraphQLContext,
} from '@ui/providers/GraphQLProvider';
import { getQuery } from '@ui/queries/queries';
import { QueryKey } from '@ui/queries/queryKey';
import { getLatomAprQuery } from '@ui/queries/subgraph';
import { getApy, getApyFromApr7d } from '@ui/utils/aprToApy';
import {
  ACTIVE_APY_MODE_LATOM,
  ApyMode,
  POST_MVP_DASHBOARD,
} from '@ui/utils/constants';
import { useContext } from 'react';

import type { CoinMode } from './useCoinMode';
import { useCoinMode } from './useCoinMode';

export const useApr = (options?: { coinMode: CoinMode }) => {
  const globalCoinMode = useCoinMode();
  const coinMode = options?.coinMode ?? globalCoinMode;
  const gqlContext = useGraphQLContext();
  let client = gqlContext.subgraphClientAtom;
  if (coinMode === 'cro') client = gqlContext.subgraphClient;
  const query =
    coinMode === 'cro'
      ? getQuery(QueryKey.APR)(client)
      : getLatomAprQuery(client);
  return useQuery(query);
};

export const useHistoricApys = () => {
  const client = useContext(GraphQLContext).subgraphClient;
  const clientAtom = useContext(GraphQLContext).subgraphClientAtom;
  const globalCoinMode = useCoinMode();
  const query = getQuery(QueryKey.HISTORIC_APYS)(
    globalCoinMode === 'atom' ? clientAtom : client,
    globalCoinMode,
  );
  return useQuery(query.queryKey, query.queryFn, {
    enabled: POST_MVP_DASHBOARD,
  });
};

export const useApy = (options?: { coinMode: CoinMode }) => {
  const globalCoinMode = useCoinMode();
  const coinMode = options?.coinMode ?? globalCoinMode;
  const aprResult = useApr({
    coinMode,
  });
  const data =
    ACTIVE_APY_MODE_LATOM === ApyMode.day && coinMode === 'atom'
      ? getApy(aprResult.data ?? 0)
      : getApyFromApr7d(aprResult.data ?? 0);

  /**
   * todo cover.lv hardcode the atom staking apy
   */
  if (coinMode === 'atom' && !aprResult.isInitialLoading && !data) {
    return { ...aprResult, data: 0.21 };
  }

  return { ...aprResult, data };
};
